export default {
    props: {
        messagesMeasureFields: {
            type: String,
            default: undefined,
            kComposite: 'messages.measureFields'
        }, 
        messagesColumnFields: {
            type: String,
            default: undefined,
            kComposite: 'messages.columnFields'
        }, 
        messagesRowFields: {
            type: String,
            default: undefined,
            kComposite: 'messages.rowFields'
        }, 
        messagesFieldMenuInfo: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.info'
        }, 
        messagesFieldMenuSortAscending: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.sortAscending'
        }, 
        messagesFieldMenuSortDescending: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.sortDescending'
        }, 
        messagesFieldMenuFilterFields: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.filterFields'
        }, 
        messagesFieldMenuFilter: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.filter'
        }, 
        messagesFieldMenuInclude: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.include'
        }, 
        messagesFieldMenuTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.title'
        }, 
        messagesFieldMenuClear: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.clear'
        }, 
        messagesFieldMenuOk: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.ok'
        }, 
        messagesFieldMenuCancel: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.cancel'
        }, 
        messagesFieldMenuOperatorsContains: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.contains'
        }, 
        messagesFieldMenuOperatorsDoesnotcontain: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.doesnotcontain'
        }, 
        messagesFieldMenuOperatorsStartswith: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.startswith'
        }, 
        messagesFieldMenuOperatorsEndswith: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.endswith'
        }, 
        messagesFieldMenuOperatorsEq: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.eq'
        }, 
        messagesFieldMenuOperatorsNeq: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.neq'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-pivotgrid-vue-wrapper/src/KendoPivotGrid/Messages.js